<script setup>

import {onMounted, reactive, ref} from "vue";
import {useBreadStore} from '@bread/js/store'
import Money from "@common/Form/Money";
import {PencilAltIcon, TrashIcon} from "@heroicons/vue/solid";
import {Link} from "@inertiajs/inertia-vue3";

const props = defineProps({
  products: Object,
  filters: Object,
  params: Object,
})

const updateUpsellPrice = (product) => {
  product.new_price = parseFloat(product.gain) + parseFloat(product.official_price);
  product.yearly_potential_upsell_gain = product.gain * product.sales;
}
</script>
<template>
  <div class="max-w-10xl mx-auto mt-5">
    <div class="flex flex-col">
      <div class="overflow-x-auto shadow-md sm:rounded-lg">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden ">
            <table class="min-w-full divide-y divide-gray-200 table-fixed ">
              <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                     <span class="inline-flex w-full justify-between cursor-pointer">
                      Hope
                    </span>
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span class="inline-flex w-full justify-between cursor-pointer">
                      Product
                    </span>
                </th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Huidige prijs</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Correctie</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Nieuwe prijs</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    title="geschatte jaarlijkse extra winst op basis van huidige correctie">
                    <span
                          class="inline-flex w-full justify-between cursor-pointer"
                          title="Extra winst die gecreëerd wordt op jaarbasis door de prijscorrectie door te voeren">
                       Correctiewinst
                    </span>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(product , index ) in props.products" :key="product.id" class="hover:bg-gray-100 "
                  :class="index % 2 === 0 ? undefined : 'bg-gray-50'">
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap "
                    :title="'EAN: ' + product.ean">{{ product.hope }}
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{ product.name }}</td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="product.official_price"
                         :id="product.id"
                         :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <input
                    class="border-gray-200 py-0.5 px-1 text-sm"
                    type="text"
                    v-model="product.gain"
                    @change="updateUpsellPrice(product)"
                    style="width: 100px"
                  />
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="parseFloat(product.new_price)"
                         :id="product.id"
                         :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                  <Money :number="product.yearly_potential_upsell_gain"
                         :id="product.id"
                         class="text-green-500"
                         :options="{prefix : '€' , cent_separator:',', thousand_separator: '.'}"/>
                </td>
                <td class="py-4 px-6 text-sm font-medium text-right whitespace-nowrap space-x-2">
                  <Link
                    :href="
                          route('admin.products.edit', [
                            product.id,
                          ])
                        "
                    class="text-dark"
                    title="edit">
                    <PencilAltIcon class="action-icons"></PencilAltIcon>
                  </Link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
